<template>
<div>
    <div class="panel panel-default">
        <div class="panel-heading">Goals</div>
        <div class="panel-body">
            <form role="form" @submit.prevent="updateView" v-if="goals.length > 0">
                <table class="table ga-views">
                    <thead>
                        <tr>
                            <th>Include</th>
                            <th>Name</th>
                            <th>Type</th>
                        </tr>
                    </thead>
					<tbody v-if="loadingGoals">
						<tr>
							<td></td>
							<td class="loading">
								<i class="fa fa-refresh fa-spin fa-fw"></i>
								<span class="sr-only">Loading...</span>
							</td>
							<td></td>
						</tr>
					</tbody>
                    <tbody v-else>
                        <tr v-for="goal in goals" :key="goal.goal_id">
                            <td><input type="checkbox" v-model="goal.status" v-bind:true-value="'1'" v-bind:false-value="'0'"></td>
                            <td>{{ goal.name }}</td>
                            <td><input class="form-control" type="text" v-model="goal.type" placeholder="Optional"></td>
                        </tr>
                    </tbody>
                </table>

                <div class="form-group">
                    <button type="submit" class="btn btn-primary w-full" :class="{'btn-loading': loading, 'btn-successful': success}" :disabled="loading">Save</button>
                </div>
            </form>
            <div v-else>
                There are no Goals in this View.
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
	mapGetters
} from 'vuex';

export default {
	data() {
		return {
            loadingGoals: true,
            loading: false,
            success: false,
            goals: []
		}
	},

	computed: {
		...mapGetters('client', {
			'client': 'activeClient',
			'isAdmin': 'isAdmin',
			'view': 'activeView',
		}),
    },

    mounted() {
        Bus.$on('load-ga-goal-list', this.prepareComponent);
    },

	methods: {
		prepareComponent() {
			this.loadingGoals = true;
			axios.get(`/api/ga/manager/goals?account=${this.view.account_id}&property=${this.view.property_id}&view=${this.view.view_id}`)
				.then((response) => {
					this.setExisingValuesForGoals(response.data);
				}).catch((response) => {
					console.log(response);
				});
		},

		setExisingValuesForGoals(goals) {
			goals.forEach((goal) => {
				let a = this.view.goals.filter((g) => {
					return g.goal_id === goal.goal_id;
				}).length;

				if (a > 0) {
					goal.type = this.view.goals.filter((g) => {
						return g.goal_id === goal.goal_id;
					})[0].type;

					goal.status = this.view.goals.filter((g) => {
						return g.goal_id === goal.goal_id;
					})[0].status;
				}
			});

			this.goals = goals;
			this.loadingGoals = false;
		},

		updateView() {
            this.loading = true;
            let goals = this.goals;
			this.$store.dispatch('client/updateGaViewGoals', {
					goals: goals
				})
				.then((response) => {
					Bus.$emit('show-success-alert', response.message);
                    this.loading = false;
                    // this.success = true;
                    // setTimeout(() => this.success = false, 2000)
				}).catch((error) => {
					console.log(error);
                    this.loading = false;
				})
		},
	}
}
</script>

<style scoped lang="scss">
table.table.ga-views {
    tbody > tr > td {
        vertical-align: middle;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/clients/GaViewGoals.vue